import { render, staticRenderFns } from "./SafariItineraryDayList.vue?vue&type=template&id=78b7de5c&scoped=true&"
import script from "./SafariItineraryDayList.vue?vue&type=script&lang=js&"
export * from "./SafariItineraryDayList.vue?vue&type=script&lang=js&"
import style0 from "./SafariItineraryDayList.vue?vue&type=style&index=0&id=78b7de5c&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b7de5c",
  null
  
)

export default component.exports